import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Content } from '@motorway/motorway-storybook-cra';

import cypressIds from 'CypressId';

import { HOMEPAGE_GA_TAGS, HOMEPAGE_SECTIONS } from 'Utilities/analytics/analyticsHomePage';
import { applyCypressData } from 'Utilities/index';
import { SELL_MY_CAR_PATH } from 'Utilities/wordpress';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import LocalTexts from '../../HomepageTexts.json';
import { CallToAction, CallToActionProps } from '../CallToAction/CallToAction';
import { Heading } from '../Heading/Heading';

import { NewsAndToolsCard } from './SubComponents/NewsAndToolsCard/NewsAndToolsCard';
import { newsAndToolsTilesContent } from './NewsAndTools.helper';

import styles from './NewsAndTools.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

const texts = {
  subTitle: t('NewsAndTools.subTitle'),
  title: t('NewsAndTools.title'),
};

const callToActionProps: CallToActionProps = {
  ctaButtonLabel: t('NewsAndTools.cta.buttonLabel'),
  ctaHref: SELL_MY_CAR_PATH,
  ctaTagline: t('NewsAndTools.cta.tagline'),
  onClick: () => HOMEPAGE_GA_TAGS.SECTION_CTA_CLICKED(HOMEPAGE_SECTIONS.NEWS_AND_TOOLS),
};

type Props = {
  readonly className?: string;
}

export const NewsAndTools = ({ className }: Props) => {
  const eventLabels = newsAndToolsTilesContent.map((card) => card.label);
  const onRefTrigger = (eventLabel?: string) => {
    HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.NEWS_AND_TOOLS, eventLabel);
  };
  const {
    $wrapper,
    isSectionVisible,
    setRef,
  } = usePageRefEvents({ eventLabels, onRefTrigger });

  const onTileClick = (eventLabel: string) => {
    HOMEPAGE_GA_TAGS.NEWS_AND_TOOLS_TILE_CLICKED(eventLabel);
  };

  return (
    <div className={cx(styles.componentWrapper, className)} {...applyCypressData(cypressIds.sections.newsAndTools)}>
      <Content className={styles.wrapperPaddingOverride}>
        <div className={styles.headingsWrapper}>
          <Heading
            subtitle={texts.subTitle}
            title={texts.title}
          />
        </div>

        <div className={styles.contentWrapper}>
          <section ref={$wrapper} className={styles.component} data-testid='newsAndTools'>
            {
              newsAndToolsTilesContent.map((tileContent, i) => (
                <NewsAndToolsCard
                  key={tileContent.label}
                  ref={(ref) => setRef(ref, i)}
                  {...{ isSectionVisible }}
                  onClick={() => onTileClick(tileContent.label)}
                  { ...tileContent } />
              ))
            }
          </section>
          <CallToAction {...callToActionProps} />
        </div>
      </Content>
    </div>
  );
};
